import React from 'react';
import { Box, Button, Group, Paper, Text, Transition } from '@mantine/core';
import { IconAlertCircle, IconDeviceFloppy } from '@tabler/icons-react';

interface BarraCambiosSinGuardarVistaProps {
    visible: boolean;
    alDescartar: () => void;
    alGuardar: () => void;
    /** Texto del botón principal (p. ej. "Guardar y recalcular" en la cotización). */
    textoGuardar?: string;
    guardando?: boolean;
}

/** Mismo color de advertencia que las alertas de la app (los colores con nombre del tema salen muy claros). */
const COLOR_ADVERTENCIA = '#e6a23c';

/**
 * Barra de guardado que aparece solo cuando hay cambios sin guardar, fija abajo del área con scroll: se puede
 * guardar desde cualquier tarjeta sin volver arriba y, sin cambios, no ocupa espacio. Discreta: centrada, del
 * ancho de su contenido y con borde suave. Debe ir al final del contenido de un contenedor con scroll (sticky).
 */
export const BarraCambiosSinGuardarVista: React.FC<BarraCambiosSinGuardarVistaProps> = ({
    visible, alDescartar, alGuardar, textoGuardar = 'Guardar Cambios', guardando = false
}) => (
    <Transition mounted={visible} transition="slide-up" duration={180} timingFunction="ease">
        {(estilos) => (
            <Box style={{ ...estilos, position: 'sticky', bottom: 12, zIndex: 20, display: 'flex', justifyContent: 'center', pointerEvents: 'none' }} mt="md" px="md">
                <Paper
                    shadow="sm"
                    radius="xl"
                    withBorder
                    pl="md"
                    pr={6}
                    py={6}
                    bg="var(--mantine-color-body)"
                    style={{ pointerEvents: 'auto', maxWidth: '100%' }}
                >
                    <Group gap="lg" wrap="wrap" justify="center">
                        <Group gap={8} wrap="nowrap">
                            <IconAlertCircle size={18} color={COLOR_ADVERTENCIA} />
                            <Text size="sm">Tienes cambios sin guardar</Text>
                        </Group>
                        <Group gap={6} wrap="nowrap">
                            <Button variant="subtle" color="gray" size="xs" radius="xl" onClick={alDescartar} disabled={guardando}>
                                Descartar
                            </Button>
                            <Button color="primary" variant="filled" size="xs" radius="xl" leftSection={<IconDeviceFloppy size={14} />} onClick={alGuardar} loading={guardando}>
                                {textoGuardar}
                            </Button>
                        </Group>
                    </Group>
                </Paper>
            </Box>
        )}
    </Transition>
);
